/**
 * streamlines add a dynamic value to borderRadius.
 * @param {object} param0
 * @param {number|string} param0.$borderRadius
 * @returns {string}
 */
const dynBorderRadius = ({ $borderRadius }) => {
  if ($borderRadius === undefined) return "";
  if (typeof $borderRadius === "number")
    return `border-radius: ${$borderRadius}px;`;
  return `border-radius: ${$borderRadius};`;
};

export default dynBorderRadius;
